import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';
class Carrusel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            images: this.props.images,
            animating: false
        }
    }

    completeArray(images){
        if(images.length === 3) return [...images, images[0]];
        if(images.length === 2) return [...images, images[0]];
        return images;
    }

    // se crea intervalo para cambiar las imagenes y se espera a que termine la animacion para cambiar el estado
    componentDidMount(){
        const { animationConfig } = this.props;
        if(!animationConfig || this.state.images.length === 1) return
        
        this.idInterval = setInterval(() => {
            if(animationConfig && typeof animationConfig.onTransition === 'function'){
                animationConfig.onTransition(this.state.images[0].id);
            }
            this.setState({ animating: true });
                this.idTimeout = setTimeout(() => {
                    this.setState((prevState) => {
                        const copy = [...prevState.images];
                        copy.push(copy.shift());
                        return { images: copy };
                    });
                    this.setState({ animating: false });
                }, 1500); // Duración de la animación en ms
        }, animationConfig.interval + 1500); // Intervalo total incluyendo la duración de la animación
    }

    componentWillUnmount(){
        clearInterval(this.idInterval);
        clearTimeout(this.idTimeout);
    }

    render() {
        const images  = this.completeArray(this.state.images);

        const imageToRender = images && images.length > 4 ? images.slice(0,4) : images;

        return(
            <div className="carrousel">
                {imageToRender && imageToRender.map(({image, id}, index) => (
                    <img
                        key={'carrousel-card-'+id+index}
                        className={`${this.state.animating ? 'carrousel-card-animating' : 'carrousel-card'} `}
                        src={image}
                        alt={`Poster ${id}`}
                    />
                ))}
            </div>
        )
    }
}

Carrusel.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            image: PropTypes.string.isRequired
        })
    ).isRequired,
    animationConfig: PropTypes.shape({
        interval: PropTypes.number.isRequired,
        onTransition: PropTypes.func
    })
};

export default Carrusel;


// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/components/carrusel/Carrusel.jsx